import {
  authSignOutSuccess,
} from "../actions";

export const authorizationHeader = (tokenType) => {
  let member;
  try {
    member = JSON.parse(localStorage.getItem("member"));
  } catch (err) {
  }
  if (member && member.token) {
    return { Authorization: `${tokenType} ${member.token}` };
  } else {
    return {};
  }
};

export const authorizationHeaderWithMultipartFormData = (tokenType) => {
  let member;
  try {
    member = JSON.parse(localStorage.getItem("member"));
  } catch (err) {
  }
  if (member && member.token) {
    return {
      Authorization: `${tokenType} ${member.token}`,
      "Content-Type": `multipart/form-data`,
    };
  } else {
    return {};
  }
};

export const getErrorMessage = (error) => {
  //TODO : message CODE
  return error.message;
};


export const getErrorMessage_v2 = (error) => {
  console.info(error)
    if(!error) return "SERVER_ERROR"
    let msg = error.data.error.message 
    switch (error.status) {
      case 401:
        localStorage.removeItem("member");
        authSignOutSuccess()
        return msg
      case 500:
          return "SERVER_ERROR"
      default:
        return msg
    }

};

export const checkLogin = () => {
  let member;
  try {
    member = JSON.parse(localStorage.getItem("member"));
  } catch (err) {
  }
  if (member && member.success) {
    return member.success;
  }
};

export const getFilterUrl = (filterObj) => {
  return (
    "?" +
    Object.keys(filterObj)
      .map(
        (key) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(filterObj[key])
      )
      .join("&")
  );
};

export const getToken = () => {
  let member;
  try {
    member = JSON.parse(localStorage.getItem("member"));
  } catch (err) {
  }
  if (member && member.token) {
    return member.token;
  }
};
